import React from "react";
import Popup from "@components/popup";
import Button from "@components/button";
import SendLogo from "../../img/send-done-logo.svg";
import WarningLogo from "../../img/warning-logo.svg";
import {
  HeaderPopupStyle,
  SubTitlePopup,
  PopupContentStyle,
} from "./Popup.styles";
import { useStore } from "../../store";
import { roles } from "../../const";
import i18nStrings from "../../strings/stings";

export const PopupSendSuccess = () => {
  const { globalModule } = useStore();
  const strings = i18nStrings;
  const { showSend, role } = globalModule;

  const getPopupSubtitle = () => {
    if (role === roles.carrier) return strings.weSendAMessageAdvancePayment;
    if (role === roles.fuel) return strings.fuelCheckAMessage;
    return strings.weSendAMessageCredit;
  };

  return (
    <Popup
      className="popup-main"
      onClose={() => showSend(false, "success")}
    >
      <Popup.Header />
      <Popup.Content>
        <PopupContentStyle>
          <img alt="" src={SendLogo} />
          <HeaderPopupStyle>{strings.aplicationSend}</HeaderPopupStyle>
          <SubTitlePopup>{getPopupSubtitle()}</SubTitlePopup>
        </PopupContentStyle>
      </Popup.Content>
      <Popup.Footer
        className="popup-footer"
        theme="white"
      >
        <Popup.ActionWrapper>
          <Button
            theme="primary"
            onClick={() => { showSend(false, "success"); }}
          >
            {strings.close}
          </Button>
        </Popup.ActionWrapper>
      </Popup.Footer>
    </Popup>
  );
};

export const PopupSendUnsuccess = () => {
  const { globalModule } = useStore();
  const { showSend, role } = globalModule;
  const strings = i18nStrings;

  const getPopupTitle = () => {
    if (role === roles.fuel) return strings.fuelAplicationInProcess;
    return strings.aplicationInProcess;
  };

  const getPopupSubtitle = () => {
    if (role === roles.carrier) return strings.avdanceAlreadySent;
    if (role === roles.fuel) return strings.fuelAvdanceAlreadySent;
    return strings.creditAlreadySent;
  };

  return (
    <Popup
      className="popup-main"
      onClose={() => showSend(false, "unsucess")}
    >
      <Popup.Header />
      <Popup.Content>
        <PopupContentStyle>
          <img alt="" src={WarningLogo} />
          <HeaderPopupStyle>{getPopupTitle()}</HeaderPopupStyle>
          <SubTitlePopup>{getPopupSubtitle()}</SubTitlePopup>
        </PopupContentStyle>
      </Popup.Content>
      <Popup.Footer
        className="popup-footer"
        theme="white"
      >
        <Popup.ActionWrapper>
          <Button
            theme="primary"
            onClick={() => { showSend(false, "unsuccess"); }}
          >
            {strings.close}
          </Button>
        </Popup.ActionWrapper>
      </Popup.Footer>
    </Popup>
  );
};
